import { isP2PWithoutIframe } from '../../../../hooks/useCheckUser';
import { callGtm } from '../../GTM/';
document.addEventListener('readystatechange', event => {
    if (!window.location.pathname.includes('checkout-page') && document.readyState === 'complete') {
        const navigationDelayNav = document.querySelector('.header__nav');
        const isHoverDelayEnabled = navigationDelayNav?.dataset?.hoverdelayenable === 'true';
        const hoverDelay = isHoverDelayEnabled ? Number(navigationDelayNav?.dataset?.hoverdelaytimeout) / 1000 || 0.3 : 0;
        document.documentElement.style.setProperty('--navigation-hover-delay', `${hoverDelay}s`);

        const dynamicDataList = [{ title: 'My Favorites', mountingClass: 'P2P_React_Mount' }];
        var headerSearchMobileBtn = document.querySelector('.header__search__mobilebtn');
        headerSearchMobileBtn?.classList?.add('header__search__mobilebtn--show');
        var sideMenu = document.querySelector('.side__menu');
        var sideMenuButton = document.querySelector('.side__menu-button');
        var headerSearchClose = document.querySelector('.header__search__close');
        var headerCarousal = document.querySelector('.header__carousel-wrapper');

        var headerCarousalItems = document.querySelectorAll('.header__carousal .item');
        var headerCarousalItemsLength = headerCarousalItems?.length;

        // function for Generate Dynamic Mobile Memu
        function generateMobileMenu() {
            // div for inserting mobile menu
            var sideMenuWrap = document.querySelector('.side__menu-wrap .show__mobile');

            // Arrary for adding Menu items
            var mobileMenuArray = [];

            // function for Add Objcet
            const addLinkTitleObject = menuItem => {
                return {
                    link: menuItem?.href?.trim(),
                    title: menuItem?.textContent?.trim(),
                    isDataDynamic: dynamicDataList.find(e => e.title === menuItem?.textContent?.trim()) || ''
                };
            };
            const createMenu = menuItems => {
                return [...menuItems]?.map(menuItem => {
                    var menuLink = menuItem?.children?.[0];
                    var subMenuItems = menuItem?.children?.[1]?.children;
                    var subMenu = subMenuItems?.length > 0 ? createMenu(subMenuItems) : null;
                    return {
                        ...addLinkTitleObject(menuLink),
                        children: subMenu
                    };
                });
            };
            const createMobileMenu = (mainMenuItems, element) => {
                mainMenuItems.forEach(mainMenuItem => {
                    var mainMenuLink = mainMenuItem?.children[0];
                    var subMenuItems = mainMenuItem?.querySelectorAll(element);
                    var subMenu = subMenuItems?.length > 0 ? createMenu(subMenuItems) : null;
                    var mainMenuObject = {
                        ...addLinkTitleObject(mainMenuLink),
                        link: mainMenuItem?.querySelector('a')?.href?.trim(),
                        children: subMenu
                    };
                    mobileMenuArray.push(mainMenuObject);
                });
            };

            // function for check 'See All text'
            const checkForSeeAll = item => {
                return item?.title?.toLowerCase() === 'see all';
            };

            // function for check length
            const checkForLength = item => {
                return item?.children?.length > 0;
            };

            // function for back button
            const backButton = (buttonclass, item) => {
                return `<button class="${buttonclass}" aria-label="Click here to go back to ${item} menu ">
                <span class="side__menu-item--back-button icon icon-chevron-left-bold" tabindex='-1' aria-hidden="true"></span>
                <p class="back__to_text">${item}</p>
             </button>`;
            };

            //Li item for back
            const liBack = (liClass, backbuttonClass, item) => {
                return `<li class="${liClass}">${backButton(backbuttonClass, item)}</li>`;
            };

            const getOtherMenus = () => {
                const megaMenuWithoutEquipements = document.querySelectorAll('.header__menu .header__nav-other');
                megaMenuWithoutEquipements.forEach(menuItem => {
                    var headerTopLink = menuItem?.querySelector('.header__nav-top-link');
                    var headerL1MenuLinks = menuItem?.querySelectorAll('.header__submenu a');
                    var otherMenuObject = addLinkTitleObject(headerTopLink);
                    otherMenuObject['children'] = [];
                    [...headerL1MenuLinks]?.map(headerL1MenuLink => {
                        otherMenuObject['children'].push(addLinkTitleObject(headerL1MenuLink));
                    });
                    mobileMenuArray.push(otherMenuObject);
                });
            };
            const getEquipmentMenu = () => {
                const megaMenuWithEquipements = document?.querySelectorAll('.header__menu .header__menu-topmain');
                createMobileMenu(megaMenuWithEquipements, '.header__level1-item');
            };

            const createDynamicObject = () => {
                getEquipmentMenu();
                getOtherMenus();
            };
            createDynamicObject();
            const generateDynamicHTML = l1MenuItem => {
                return `<li class="side__menu-item side__menu-item-toplevel">
                <a href="${l1MenuItem?.link || '#'}" class="side__menu-link all__rentals_text__title_mob">${
                    l1MenuItem?.title
                }</a>
                ${
                    checkForLength(l1MenuItem) || l1MenuItem?.isDataDynamic
                        ? `<button class="side__menu-item-button side__menu-button-1 icon icon-chevron-right-bold" aria-label="click for view ${l1MenuItem?.title} items" aria-expanded="false"></button>`
                        : ''
                }
               ${
                   checkForLength(l1MenuItem)
                       ? `<ul class="side__submenu">
                       ${liBack(
                           'side__menu-item side__menu-item-top side__menu-item-sublevel',
                           'back_main_menu',
                           l1MenuItem?.title
                       )}
                       ${l1MenuItem?.children
                           .map(l2MenuItem => {
                               return `<li class="side__menu-item side__menu-item-sublevel">
               <a class="side__menu-link all__rentals_text__l2_mob" href="${l2MenuItem.link || '#'}">${
                                   l2MenuItem.title
                               }</a>
               ${
                   checkForLength(l2MenuItem)
                       ? `<button class="side__menu-item-button side__menu-button-2 icon icon-chevron-right-bold" aria-label="click for view ${l2MenuItem?.title} items" aria-expanded="false"></button>`
                       : ''
               }
               ${
                   checkForLength(l2MenuItem)
                       ? `<ul class="side__sub-submenu">
            ${liBack(
                'side__menu-item side__menu-item-top side__menu-item-sub-sublevel',
                'back_sub_menu',
                l2MenuItem?.title
            )}
            ${l2MenuItem?.children
                ?.map(
                    l3MenuItem => `
             <li class="${
                 checkForSeeAll(l3MenuItem) ? 'header__level2-item' : 'side__menu-item side__menu-item-sub-sublevel'
             }">
               <a href="${l3MenuItem.link}" class=" ${
                        checkForSeeAll(l3MenuItem)
                            ? 'header__submenu-link header__submenu__link header__submenu-seeall'
                            : 'side__menu-link all__rentals_text__l3_mob'
                    }">${l3MenuItem.title}</a>
               ${
                   checkForLength(l3MenuItem)
                       ? `<button class="side__menu-item-button side__menu-button-3 icon icon-chevron-right-bold" aria-label="click for view ${l3MenuItem?.title} items" aria-expanded="false"></button>`
                       : ''
               }
               ${
                   checkForLength(l3MenuItem)
                       ? `<ul class="side__sub-sub-submenu">
            ${liBack(
                'side__menu-item side__menu-item-top side__menu-item-sublevel side__menu-item-sub-sublevel',
                'back_sub_sub_menu',
                l3MenuItem?.title
            )}
            ${l3MenuItem?.children
                ?.map(
                    subsubmenu => `<li class="${
                        checkForSeeAll(subsubmenu)
                            ? ' header__level3-item'
                            : 'side__menu-item side__menu-item-sublevel side__menu-item-sub-sublevel'
                    }">
             <a class=" ${
                 checkForSeeAll(subsubmenu)
                     ? ' header__submenu-link header__submenu__link header__submenu-seeall'
                     : 'side__menu-link'
             }" href="${subsubmenu.link || '#'}">${subsubmenu.title}</a></li>`
                )
                .join('')
                .trim()}
               </ul>`
                       : ''
               }
               </li>`
                )
                .join('')
                .trim()}
               </ul>`
                       : ''
               }
               </li>`
                           })
                           .join('')
                           .trim()}</ul>`
                       : l1MenuItem?.isDataDynamic
                       ? `<div class="${l1MenuItem?.isDataDynamic?.mountingClass} side__submenu"></div>`
                       : ''
               }
               
               </li>`;
            };

            mobileMenuArray?.map(item => {
                var ulcomponent = document?.createElement('ul');
                ulcomponent.innerHTML = generateDynamicHTML(item);
                sideMenuWrap?.appendChild(ulcomponent);
            });
        }
        // calling function for mobile menu generate
        generateMobileMenu();

        if (headerCarousalItems) {
            if (headerCarousalItemsLength === 1) {
                headerCarousal?.querySelector('.header__carousal')?.classList.add('header__carousal-hidebuttons');
            } else {
                headerCarousal?.querySelector('.header__carousal')?.classList.add('header__carousal-showbuttons');
            }
        }

        if (headerCarousal?.childElementCount === 0) {
            headerCarousal?.closest('.header__top')?.classList?.add('is-empty');
        }
        var trapFocus = element => {
            var focusableEls = element.querySelectorAll(
                'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), h1, h2, h3, h4, h5, h6, strong, b'
            );
            var firstFocusableEl = focusableEls[0];
            //firstFocusableEl.focus();
            var lastFocusableEl = focusableEls[focusableEls.length - 1];
            var KEYCODE_TAB = 9;
            element.addEventListener('keydown', function (e) {
                var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
                if (!isTabPressed) {
                    return;
                }
                if (e.shiftKey) {
                    /* shift + tab */ if (document.activeElement === firstFocusableEl) {
                        lastFocusableEl.focus();
                        e.preventDefault();
                    }
                } /* tab */ else {
                    if (document.activeElement === lastFocusableEl) {
                        firstFocusableEl.focus();
                        e.preventDefault();
                    }
                }
            });
        };

        var setToggleState = false;
        var setAriaHiddenTrue = () => {
            const formContainerInput = document.querySelector('.formContainer .cmp-Field__field__input ');
            const searchIconClass = document.querySelector('.searchIconClass');
            const cartTrigger = document.querySelector('.cmp-CartTrigger__cartTrigger__root');
            const headerLocation = document.querySelector('.header__setlocation-button');
            if (formContainerInput) {
                formContainerInput.ariaHidden = 'true';
                formContainerInput.tabIndex = '-1';
            }
            if (searchIconClass) {
                searchIconClass.ariaHidden = 'true';
                searchIconClass.tabIndex = '-1';
            }
            if (cartTrigger) {
                cartTrigger.ariaHidden = 'true';
                cartTrigger.tabIndex = '-1';
            }
            if (headerLocation) {
                headerLocation.ariaHidden = 'true';
                headerLocation.tabIndex = '-1';
            }
        };
        var setAriaHiddenFalse = () => {
            const formContainerInput = document.querySelector('.formContainer .cmp-Field__field__input ');
            const searchIconClass = document.querySelector('.searchIconClass');
            const cartTrigger = document.querySelector('.cmp-CartTrigger__cartTrigger__root');
            const headerLocation = document.querySelector('.header__setlocation-button');
            if (formContainerInput) {
                formContainerInput.ariaHidden = 'false';
                formContainerInput.tabIndex = '0';
            }
            if (searchIconClass) {
                searchIconClass.ariaHidden = 'false';
                searchIconClass.tabIndex = '0';
            }
            if (cartTrigger) {
                cartTrigger.ariaHidden = 'false';
                cartTrigger.tabIndex = '0';
            }
            if (headerLocation) {
                headerLocation.ariaHidden = 'false';
                headerLocation.tabIndex = '0';
            }
        };

        var setTrapFocus = () => {
            setAriaHiddenTrue();
            trapFocus(sideMenu);
        };

        const resetMobileMenu = () => {
            const activeMenus = document.querySelectorAll('.side__menu-item.active');
            activeMenus?.forEach(menu => menu?.classList?.remove('active'));
        };

        var handleSidebarToggle = function () {
            setToggleState = !setToggleState;
            sideMenu.classList.toggle('active');
            if (isP2PWithoutIframe()) {
                sideMenu.classList.toggle('add_top_margin');
            }
            sideMenuButton.classList.toggle('active');
            document.querySelector('body').classList.toggle('body--overflow-hidden');
            if (setToggleState) {
                setTrapFocus()
            } else {
                setAriaHiddenFalse();
                resetMobileMenu();
            }
        };

        headerSearchMobileBtn?.addEventListener('click', handleSidebarToggle);
        headerSearchClose?.addEventListener('click', handleSidebarToggle);
        sideMenuButton?.addEventListener('click', handleSidebarToggle);
        document.body.addEventListener('click', function (event) {
            const target = event.target;

            // .side__menu-button-1 click
            if (target.matches('.side__menu-button-1')) {
                target.setAttribute('aria-expanded', 'true');
                const parent = target.parentElement;
                if (parent) {
                    parent.classList.add('active');
                    [...parent.parentElement.children].forEach(sibling => {
                        if (sibling !== parent) sibling.classList.remove('active');
                    });
                }
                [...target.parentElement.children].forEach(sibling => {
                    if (sibling !== target) sibling.classList.remove('active');
                });
                const aside = target.closest('aside');
                if (aside) aside.classList.add('aside-overflow-hidden');
            }

            // .side__menu-button-1 in footer
            if (target.matches('.side__menu-item-toplevel_footer .side__menu-item-button.side__menu-button-1')) {
                const aside = target.closest('aside');
                if (aside && aside.classList.contains('aside-overflow-hidden')) {
                    aside.classList.remove('aside-overflow-hidden');
                }
                if (aside) {
                    aside.scrollTo(0, 0);
                    aside.classList.add('aside-overflow-hidden');
                }
            }

            // .side__menu-button-2 click
            if (target.matches('.side__menu-button-2')) {
                target.setAttribute('aria-expanded', 'true');
                const submenu = target.closest('.side__submenu');
                if (submenu) submenu.classList.add('side__submenu-hidden');
                const parent = target.parentElement;
                if (parent) {
                    parent.classList.add('active');
                    [...parent.parentElement.children].forEach(sibling => {
                        if (sibling !== parent) sibling.classList.remove('active');
                    });
                }
            }

            // .side__menu-button-3 click
            if (target.matches('.side__menu-button-3')) {
                target.setAttribute('aria-expanded', 'true');
                const subSubmenu = target.closest('.side__sub-submenu');
                if (subSubmenu) subSubmenu.classList.add('side__submenu-hidden');
                const parent = target.parentElement;
                if (parent) {
                    parent.classList.add('active');
                    [...parent.parentElement.children].forEach(sibling => {
                        if (sibling !== parent) sibling.classList.remove('active');
                    });
                }
            }

            // .back_sub_menu click
            if (target.closest('.back_sub_menu')) {
                const submenu = target.closest('.side__submenu');
                if (submenu) submenu.classList.remove('side__submenu-hidden');

                const sublevel = target.closest('.side__menu-item-sublevel');
                if (sublevel) {
                    sublevel.classList.remove('active');
                    const button = sublevel.querySelector('.side__menu-item-button.side__menu-button-2');
                    if (button) button.setAttribute('aria-expanded', 'false');
                }
            }

            // .back_sub_sub_menu click
            if (target.closest('.back_sub_sub_menu')) {
                const subSubmenu = target.closest('.side__sub-submenu');
                if (subSubmenu) subSubmenu.classList.remove('side__submenu-hidden');

                const subSubLevel = target.closest('.side__menu-item-sub-sublevel.active');
                if (subSubLevel) {
                    subSubLevel.classList.remove('active');
                    const button = subSubLevel.querySelector('.side__menu-item-button.side__menu-button-3');
                    if (button) button.setAttribute('aria-expanded', 'false');
                }
            }

            // .back_main_menu click
            if (target.closest('.back_main_menu')) {
                const toplevel = target.closest('.side__menu-item-toplevel');
                if (toplevel) {
                    toplevel.classList.remove('active');
                    const button = toplevel.querySelector('.side__menu-item-button.side__menu-button-1');
                    if (button) button.setAttribute('aria-expanded', 'false');
                }
                const aside = target.closest('aside');
                if (aside) aside.classList.remove('aside-overflow-hidden');
            }

            // .back_main_menu_footer click
            if (target.closest('.back_main_menu_footer')) {
                const footer = target.closest('.side__menu-item-toplevel_footer');
                if (footer) {
                    footer.classList.remove('active');
                    const button = footer.querySelector('.side__menu-item-button.side__menu-button-1');
                    if (button) button.setAttribute('aria-expanded', 'false');
                }
                const aside = target.closest('aside');
                if (aside) aside.classList.remove('aside-overflow-hidden');
            }
        });
          

        var headerMenuTopmain = $('.header__menu-topmain');
        const getScrollHeight = element => {
            return element?.scrollHeight;
        };
        const getOffsetHeight = element => {
            return element?.offsetHeight;
        };

        var slideIndex = 1;

        showSlides(slideIndex);
        if (
            document.querySelector('.header__carousal-prev') !== null &&
            document.querySelector('.header__carousal-prev') !== undefined
        ) {
            document.querySelector('.header__carousal-prev').addEventListener('click', function () {
                plusSlides(-1);
            });
        }
        if (
            document.querySelector('.header__carousal-next') !== null &&
            document.querySelector('.header__carousal-next') !== undefined
        ) {
            document.querySelector('.header__carousal-next').addEventListener('click', function () {
                plusSlides(1);
            });
        }
        function plusSlides(n) {
            showSlides((slideIndex += n));
        }
        function currentSlide(n) {
            showSlides((slideIndex = n));
        }
        function showSlides(n) {
            var i;
            var slides = document.getElementsByClassName('item');
            if (n > slides.length) {
                slideIndex = 1;
            }
            if (n < 1) {
                slideIndex = slides.length;
            }
            for (i = 0; i < slides.length; i++) {
                if (slides[i] !== null && slides[i] !== undefined) {
                    slides[i].style.display = 'none';
                }
            }
            if (slides[slideIndex - 1]) {
                slides[slideIndex - 1].style.display = 'block';
            }
        }


        function createScroller(id, iconId) {
            const scrollContainer = document.querySelector(id);
            let offsetHeight = getOffsetHeight(scrollContainer);
            let scrollHeight = getScrollHeight(scrollContainer);
            const ITEM_HEIGHT = parseInt(scrollHeight / document.querySelector(id)?.childElementCount) * 2;
            //use id to create unique icon ids
            const icondown = document.querySelector(`.icondown${iconId}`);
            const iconup = document.querySelector(`.iconup${iconId}`);

            scrollContainer?.addEventListener('scroll', function (event) {
                var element = event.target;
                var diffenrece =
                    parseInt(element.scrollTop) + parseInt(element.offsetHeight) - parseInt(element.scrollHeight);
                if (diffenrece > -2 && diffenrece <= 2) {
                    icondown.classList.remove('show');
                    iconup.classList.add('show');
                }
                if (parseInt(element.scrollTop) <= 0) {
                    iconup.classList.remove('show');
                    icondown.classList.add('show');
                }
            });

            let offSetPrev = -1;
            if (scrollHeight > offsetHeight) {
                scrollContainer.classList.add('header__menu-large');
                icondown.classList.add('show');
            }
            const handleScrollUp = () => {
                let scrollTop = scrollContainer.scrollTop;

                scrollTop = parseInt(scrollTop) + parseInt(ITEM_HEIGHT);

                if (
                    parseInt(scrollContainer.scrollTop) + parseInt(scrollContainer.offsetHeight) !==
                    parseInt(scrollContainer.scrollHeight)
                ) {
                    offSetPrev = scrollTop;
                    scrollContainer.scrollBy(0, ITEM_HEIGHT);
                    var diffenrece =
                        parseInt(scrollContainer.scrollTop) +
                        parseInt(scrollContainer.offsetHeight) -
                        parseInt(scrollContainer.scrollHeight);
                    if (diffenrece > -2 && diffenrece <= 2) {
                        icondown.classList.remove('show');
                        iconup.classList.add('show');
                    }
                } else {
                    scrollContainer.scrollBy(0, -ITEM_HEIGHT);
                    icondown.classList.remove('show');
                    iconup.classList.add('show');
                }
            };

            const handleScrollDown = () => {
                let scrollTop = scrollContainer.scrollTop;
                scrollTop = scrollTop - ITEM_HEIGHT;
                offSetPrev = scrollTop;
                scrollContainer.scrollBy(0, -ITEM_HEIGHT);
                if (scrollTop < 0) {
                    iconup.classList.remove('show');
                    icondown.classList.add('show');
                }
            };
            icondown.addEventListener('click', handleScrollUp);
            iconup.addEventListener('click', handleScrollDown);
        }

        headerMenuTopmain.hover(function () {
            document.querySelector('.header__menu-level1').scrollTo(0, 0);
            createScroller('.header__menu-level1', 1);
        });

        const submenu2Items = document.querySelectorAll('.header__level1-item');
        // let hoverTimeout2;
        const openL2Drawer = (item) => {
            // clearTimeout(hoverTimeout2);
            // hoverTimeout2 = setTimeout(() => {
                submenu2Items.forEach(sib => sib.classList.remove('active'));
                item.classList.add('active');

                document.querySelectorAll('.iconup2, .icondown2').forEach(el => el.classList.remove('show'));
                document.querySelector('.header__menu2').innerHTML = '';
                document.querySelector('.header__menu3').innerHTML = '';
                document.querySelectorAll('.iconup3, .icondown3').forEach(el => el.classList.remove('show'));

                const level2Menu = item.querySelector('.header__menu-level2');
                if (level2Menu) {
                    const clonedMenu = level2Menu.cloneNode(true);
                    document.querySelector('.header__menu2').appendChild(clonedMenu);
                }

                document.querySelector('.header__menu2').insertAdjacentHTML(
                    'beforeend',
                    `
                <button class="header__submenu-action icondown2" aria-label="Click here to scroll down">
                    <span class="icon icon-chevron-down-thin"></span>
                </button>
                <button class="header__submenu-action iconup2" aria-label="Click here to scroll up">
                    <span class="icon icon-chevron-up-thin"></span>
                </button>
            `
                );

                createScroller('.header__menu2 > .header__menu-level2', 2);

                let l2Items = document.querySelectorAll('.header__menu2 .header__level2-item');
                l2Items?.forEach(l2item => {
                    const itemLink = l2item.querySelector('.header__submenu-link');
                    itemLink.addEventListener('focus', (e) => {
                        openL3Drawer(e);
                    });
                    itemLink.addEventListener('mouseenter', (e) => {
                        openL3Drawer(e);
                    });
                });
            // }, hoverDelay);
        };

        submenu2Items.forEach(item => {
            const itemLink = item.querySelector('.header__submenu-link');
            itemLink.addEventListener('focus', () => {
                openL2Drawer(item);
            });

            item.addEventListener('mouseenter', () => {
                openL2Drawer(item);
            });

            // item.addEventListener('mouseleave', () => {
            //     clearTimeout(hoverTimeout2);
            // });
        });

        // Level 3 menu handler
        // let hoverTimeout3;

        const openL3Drawer = (e) => {
            if (e.target.closest('.header__menu2 .header__level2-item')) {
                const target = e.target.closest('.header__menu2 .header__level2-item');
                // clearTimeout(hoverTimeout3);
                // hoverTimeout3 = setTimeout(() => {
                    document
                        .querySelectorAll('.header__menu2 .header__level2-item')
                        .forEach(el => el.classList.remove('active'));
                    target.classList.add('active');

                    document.querySelectorAll('.iconup3, .icondown3').forEach(el => el.classList.remove('show'));
                    document.querySelector('.header__menu3').innerHTML = '';

                    const level3Menu = target.querySelector('.header__menu-level3');
                    if (level3Menu) {
                        const clonedMenu = level3Menu.cloneNode(true);
                        document.querySelector('.header__menu3').appendChild(clonedMenu);
                    }

                    document.querySelector('.header__menu3').insertAdjacentHTML(
                        'beforeend',
                        `
            <button class="header__submenu-action icondown3" aria-label="Click here to scroll down">
                <span class="icon icon-chevron-down-thin"></span>
            </button>
            <button class="header__submenu-action iconup3" aria-label="Click here to scroll up">
                <span class="icon icon-chevron-up-thin"></span>
            </button>
        `
                    );

                    createScroller('.header__menu3 > .header__menu-level3', 3);
                // }, hoverDelay);
            }
        }

        document.addEventListener(
            'keydown',
            function (e) {
                if(e.code === 'ArrowRight') {
                    if (e.target.closest('.header__menu2 .header__level2-item')) {
                        document.querySelector('.header__menu3 .header__level3-item .header__submenu-link').focus();
                    }
                    else if(e.target.closest('.header__level1-item.active')) {
                        document.querySelector('.header__menu2 .header__level2-item .header__submenu-link').focus();
                    }
                }
                else if(e.code === 'ArrowLeft') {
                    if (e.target.closest('.header__menu-level3 .header__level3-item')) {
                        document.querySelector('.header__menu2 .header__level2-item.active .header__submenu-link').focus();
                    }
                    else if(e.target.closest('.header__menu2 .header__level2-item')) {
                        document.querySelector('.header__level1-item.active .header__submenu-link').focus();
                    }
                }
            }
        );

        // document.addEventListener(
        //     'mouseleave',
        //     function (e) {
        //         if (e.target.closest?.('.header__menu2 .header__level2-item')) {
        //             clearTimeout(hoverTimeout3);
        //         }
        //     },
        //     true
        // );



        var isGTMHidden = document.querySelector('meta[name="hideGTM"]')?.content;
        if (isGTMHidden === 'false') {
            var navHeaders = document.querySelectorAll('.header__menu__link');
            navHeaders?.forEach(header_l1 => {
                header_l1?.addEventListener('click', function (e) {
                    var eventCategory = 'main menu L1';
                    var eventLabel = header_l1.innerText;
                    callGtm('uaevent', 'undefined', eventCategory, 'select', eventLabel);
                });
            });

            var navHeaders_l2 = document.querySelectorAll('.header__level1-item .header__submenu-link');
            navHeaders_l2?.forEach(header_l2 => {
                header_l2?.addEventListener('click', function (e) {
                    var eventCategory = 'main menu L2';
                    var eventLabel = e.target.innerText;
                    callGtm('uaevent', 'undefined', eventCategory, 'select', eventLabel);
                });
            });

            var navHeadersSub_l2 = document.querySelectorAll('.header__submenu__column__link');
            navHeadersSub_l2?.forEach(headerSub_l2 => {
                headerSub_l2?.addEventListener('click', function (e) {
                    var eventCategory = 'main menu L2';
                    var eventLabel = e.target.innerText;
                    callGtm('uaevent', 'undefined', eventCategory, 'select', eventLabel);
                });
            });

            var navHeaders_l3 = document.querySelectorAll('.header__menu2');
            navHeaders_l3?.forEach(header_l3 => {
                header_l3?.addEventListener('click', function (e) {
                    var eventCategory = 'main menu L3';
                    var eventLabel = e.target.innerText;
                    callGtm('uaevent', 'undefined', eventCategory, 'select', eventLabel);
                });
            });

            var navHeaders_l4 = document.querySelectorAll('.header__menu3');
            navHeaders_l4?.forEach(header_l4 => {
                header_l4?.addEventListener('click', function (e) {
                    var eventCategory = 'main menu L4';
                    var eventLabel = e.target.innerText;
                    callGtm('uaevent', 'undefined', eventCategory, 'select', eventLabel);
                });
            });
        }

        var resourceContainer = document.querySelectorAll('.accessibilitydropdown');
        if (resourceContainer) {
            resourceContainer?.forEach(function (item) {
                var dropdownBtn = item?.querySelector('button');
                if (dropdownBtn) {
                    item?.addEventListener('mouseover', () => {
                        dropdownBtn.ariaExpanded = 'true';
                    });

                    item?.addEventListener('focusin', event => {
                        dropdownBtn.ariaExpanded = 'true';
                    });

                    item?.addEventListener('focusout', event => {
                        dropdownBtn.ariaExpanded = 'false';
                    });

                    item?.addEventListener('mouseout', () => {
                        dropdownBtn.ariaExpanded = 'false';
                    });
                }
            });
        }

        //topLevel Menu
        const headerNavTopItems = document?.querySelectorAll('.header__nav-top-item');
        headerNavTopItems.forEach(menuItem => {
            const headerTopMenuButton = menuItem?.querySelector('.header__menu-icon');
            const headerSubmenu = menuItem?.querySelector('.header__submenu');
            const headerNavLink = menuItem?.querySelector('.header__nav-top-link');
            // let hoverTimeout;

            /** removes focus from L1 items and remove L2 and L3 items */
            const resetMenuAndFocus = () => {
                submenu2Items?.forEach(sib => sib?.classList?.remove('active'));
                document.querySelector('.header__menu2').innerHTML = '';
                document.querySelector('.header__menu3').innerHTML = '';
            }
        
            const activateMenu = () => {
                // clearTimeout(hoverTimeout);
                // hoverTimeout = setTimeout(() => {
                    menuItem?.classList?.add('header__nav-top-item--active');
                    headerTopMenuButton?.setAttribute('aria-expanded', 'true');
                    headerSubmenu?.classList?.add('header__submenu--active');
                    if (menuItem?.classList?.contains('header__menu-topitem')) { // for equipment and tools menu    
                        menuItem?.classList?.add('menu-active');
                    }
                // }, hoverDelay);
            };
        
            const deactivateMenu = () => {
                // clearTimeout(hoverTimeout);
                menuItem?.classList?.remove('header__nav-top-item--active', 'menu-active');
                headerTopMenuButton?.setAttribute('aria-expanded', 'false');
                headerSubmenu?.classList?.remove('header__submenu--active');
                resetMenuAndFocus();
            };
        
            menuItem?.addEventListener('mouseenter', activateMenu);
            menuItem?.addEventListener('mouseleave', deactivateMenu);

            headerTopMenuButton?.addEventListener('keydown', function (e) {
                const isEnterOrSpacePressed = e.code === 'Enter' || e.code === 'Space';
                if (isEnterOrSpacePressed) {
                    e.preventDefault();
                    if (headerTopMenuButton?.getAttribute('aria-expanded') === 'false') {
                        activateMenu();
                    } else {
                        deactivateMenu();
                    }
                }
            });
        
            headerTopMenuButton?.addEventListener('click', () => {
                const isExpanded = headerTopMenuButton?.getAttribute('aria-expanded') === 'true';
                if (isExpanded) {
                    deactivateMenu();
                } else {
                    activateMenu();
                }
            });
        
            menuItem?.addEventListener('focusout', event => {
                if (!menuItem?.contains(event?.relatedTarget)) {
                    deactivateMenu();
                }
            });
        
            menuItem?.addEventListener('keydown', event => {
                if (event.key === 'Escape') {
                    deactivateMenu();
                    headerNavLink?.focus();
                }
            });
        });
        
        // Add immediate menu activation for main menu items
        const mainMenuItems = document.querySelectorAll('.header__menu-topitem');
        mainMenuItems?.forEach(item => {
            // let menuTimeout;
            
            item?.addEventListener('mouseenter', () => {
                // clearTimeout(menuTimeout);
                // menuTimeout = setTimeout(() => {
                    item?.classList?.add('menu-active');
                // }, hoverDelay);
            });

            item?.addEventListener('mouseleave', () => {
                // clearTimeout(menuTimeout);
                item?.classList?.remove('menu-active');
            });
        });
    }
});
